import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-settings-call-list',
  templateUrl: './org-settings-call-list.component.html',
  styleUrls: ['./org-settings-call-list.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSettingsCallListComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
